import { Location } from '@angular/common';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth.service';
import { SidenavService } from 'src/app/services/sidenav.service';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, AfterViewInit {

    constructor(
        public sidenav: SidenavService,
        private auth: AuthService,
        private router: Router,
        private title: Title,
        private location: Location
    ) { }

    userData: any = {};
    lModal: any;
    currentTitle: any = null;
    routeList: any[] = [];
    showSidenav = false;

    goLogout(): void {
        this.auth.logout();
        this.showSidenav = false;
    }

    back(): void {
        this.location.back();
    }

    ngOnInit(): void {
        this.userData = this.auth.userData;
        this.router.config.forEach((item: any) => {
            if (item.children?.length) {
                item.children.forEach((cItem: any) => {
                    const path = (cItem.path) ? item.path + '/' + cItem.path : item.path;
                    this.routeList.push({ path: '/' + path, title: cItem.data?.title });
                });
            } else {
                this.routeList.push({ path: '/' + item.path, title: item.data?.title });
            }
        });
    }

    ngAfterViewInit(): void {
        this.router.events.pipe(filter(event => event instanceof NavigationEnd),
            distinctUntilChanged()
        ).subscribe((event: any) => {
            const path = event.url.split('?')[0];
            const cTitle = this.routeList.find((e: any) => e.path == path) || {};
            console.log(cTitle.title, path);
            this.currentTitle = cTitle.title;
            this.title.setTitle((this.currentTitle || 'Home') + ' | MFGM');
        });
    }

}
